/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../../shared/Button/Button';
import SecondaryButton from '../../shared/SecondaryButton/SecondaryButton';
import DeleteIcon from '../Inbox/DeleteIcon';
import IRTMessageBody from '../IRTMessageBody/IRTMessageBody';
import Message from '../Message/Message';
import MessageBody from '../MessageBody/MessageBody';
import PrintIcon from './PrintIcon';
import styles from './ViewBody.module.scss';

const cx = classnames.bind(styles);

const ViewBody = ({
  message = {},
  openModal,
  theme,
  transition,
  viewSent = false
}) => {
  const { canReply = true } = message;
  return (
    <div className={styles['view-body']}>
      <main className={styles['message-body']}>
        <div className={styles['mobile-message-buttons']}>
          <div className={styles['left-buttons']}>
            {!viewSent && (
              <div className={styles['icon-button']}>
                <a
                  alt="delete"
                  className={styles['trash-icon']}
                  id="delete-icon"
                  onClick={() =>
                    openModal({
                      message: { ...message },
                      type: 'delete'
                    })
                  }
                >
                  <DeleteIcon theme={theme}></DeleteIcon>
                </a>
              </div>
            )}
            <div className={styles['icon-button']}>
              <a
                alt="print"
                className={styles['print-icon']}
                id="print-icon"
                onClick={() => {}}
              >
                <PrintIcon theme={theme}></PrintIcon>
              </a>
            </div>
          </div>
        </div>
        <div className={styles['message-content']}>
          <Message {...message}>
            {message.isIrt ? (
              <IRTMessageBody {...message} />
            ) : (
              <MessageBody {...message} />
            )}
          </Message>
        </div>
        <div className={styles['message-buttons']}>
          <div className={styles['left-buttons']}>
            {!viewSent && (
              <div className={styles['icon-button']}>
                <a
                  alt="delete"
                  className={`${cx(
                    styles['trash-icon']
                  )} delete-msg branded-icon`}
                  id="delete-icon"
                  onClick={() =>
                    openModal({
                      message: { ...message },
                      type: 'delete'
                    })
                  }
                  type="image"
                >
                  <DeleteIcon theme={theme}></DeleteIcon>
                </a>
              </div>
            )}
            <div className={styles['icon-button']}>
              <a
                alt="print"
                className={`${styles['print-icon']} branded-icon`}
                id="print-icon"
                onClick={print}
              >
                <PrintIcon theme={theme}></PrintIcon>
              </a>
            </div>
            {viewSent && (
              <SecondaryButton
                className={styles['close-button']}
                id="close-message"
                onClick={() => transition('back')}
              >
                Close
              </SecondaryButton>
            )}
          </div>
          <div className={styles['right-buttons']}>
            {!viewSent && (
              <SecondaryButton
                className={styles['close-button']}
                id="close-message"
                onClick={() => transition('back')}
              >
                Close
              </SecondaryButton>
            )}
            {!viewSent && canReply && (
              <Button
                className={`${styles['reply-button']} branded-primary-button`}
                id="view-send-message"
                onClick={() =>
                  transition('reply', {
                    selectedMessage: message
                  })
                }
              >
                Reply
              </Button>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

ViewBody.propTypes = {
  message: PropTypes.shape({
    canReply: PropTypes.bool,
    date: PropTypes.string,
    isIrt: PropTypes.bool,
    messageId: PropTypes.string,
    messageImageUrl: PropTypes.string,
    messageText: PropTypes.string,
    title: PropTypes.string
  }),
  openModal: PropTypes.func,
  theme: PropTypes.oneOf(['ak529']),
  transition: PropTypes.func,
  viewSent: PropTypes.bool
};

export default ViewBody;
